export default "__VITE_ASSET__DtKvB6KP__"